import { useApplication } from "@/providers/application-context-provider";

const withApplication = <P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  return function WithApplicationComponent(props: P) {
    const { applicationName } = useApplication();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} application={applicationName} />;
  };
};

export default withApplication;
